import { render } from "./FilterBarComponent.vue?vue&type=template&id=651e5c4b"
import script from "./FilterBarComponent.vue?vue&type=script&lang=js"
export * from "./FilterBarComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/twilkinson/Documents/DevProjects/AF3/af3-shortcodes-plugin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__